import { render, staticRenderFns } from "./ProfilePreferences.vue?vue&type=template&id=98c10906&"
import script from "./ProfilePreferences.vue?vue&type=script&lang=js&"
export * from "./ProfilePreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports